export interface BatchCollectionMgmtCollectionBulkRemovalRequest {
  rdoRemovalType: string
  removalDateFrom: string
  removalDateTo: string
  holdingBranch: string
  rdoCollectionStatus: string
  missingCountFrom: string
  missingCountTo: string
  lastLendDate: string
  limitLendCount: string
  rdoCollectionType: string
  collectionTypeList: string
  rdoHandlingType: string
  handlingTypeList: string
  rdoShelfType: string
  shelfTypeList: string
  removeReason: string
  rdoLastCollectionRemoval: string
  isOutputList: boolean
  isOutputBookPrice: boolean
  rdoDatabaseUpdate: string
  memo: string
  batchType: string
}

export function BatchCollectionMgmtCollectionBulkRemovalRequestToJSON(
  value: BatchCollectionMgmtCollectionBulkRemovalRequest
): any {
  return {
    rdo_removal_type: value.rdoRemovalType,
    removal_date_from: value.removalDateFrom,
    removal_date_to: value.removalDateTo,
    holding_branch: value.holdingBranch,
    rdo_collection_status: value.rdoCollectionStatus,
    missing_count_from: value.missingCountFrom,
    missing_count_to: value.missingCountTo,
    last_lend_date: value.lastLendDate,
    limit_lend_count: value.limitLendCount,
    rdo_collection_type: value.rdoCollectionType,
    collection_type_list: value.collectionTypeList,
    rdo_handling_type: value.rdoHandlingType,
    handling_type_list: value.handlingTypeList,
    rdo_shelf_type: value.rdoShelfType,
    shelf_type_list: value.shelfTypeList,
    remove_reason: value.removeReason,
    rdo_last_collection_removal: value.rdoLastCollectionRemoval,
    is_output_list: value.isOutputList,
    is_output_book_price: value.isOutputBookPrice,
    rdo_database_update: value.rdoDatabaseUpdate,
    memo: value.memo,
    batch_type: value.batchType
  }
}
